<template>
  <div class="tag-box">
    <h2 v-if="header" class="tag-box__header">{{ header }}</h2>
    <div class="tag-box__content">
      <div class="tag-box__item"
        v-for="(item, idx) in itemsArr"
        :key="idx"
      >
        {{ item.Name }}
        <CloseIcon @click="deleteTag(item.Id)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import CloseIcon from '@/components/icons/CloseIcon.vue'

export default {
  name: 'TagBox',
  components: {
    CloseIcon
  },
  props: {
    header: {
      type: String,
      default: ''
    },
    textBtn: {
      type: String,
      default: 'Добавить новый тег'
    },
    categoryId: {
      type: Number,
      default: 0
    },
    itemsArr: {
      type: Array,
      default: () => []
    },
    typeTag: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const store = useStore()

    const deleteTag = (id) => {
      // разделение логики на два проекта с привязкой к значению из localStorage
      if (localStorage.activeProject === 'site') {
        if (props.categoryId === 3) {
          if (props.typeTag === 'inner') {
            store.dispatch('setDeleteCacheInnerTag', id)
          } else {
            store.dispatch('setDeleteCacheInnerKeywords', id)
          }
        } else if (props.categoryId === 2) {
          if (props.typeTag === 'inner') {
            store.dispatch('setDeleteCacheInnerTagNews', id)
          } else {
            store.dispatch('setDeleteCacheInnerKeywordsNews', id)
          }
        } else if (props.categoryId === 4) {
          if (props.typeTag === 'inner') {
            store.dispatch('setDeleteCacheInnerTagServices', id)
          } else {
            store.dispatch('setDeleteCacheInnerKeywordsServices', id)
          }
        }
      } else if (localStorage.activeProject === 'education') {
        if (props.typeTag === 'inner') {
          store.dispatch('setDeleteCacheInnerTagEducation', id)
        } else if (props.typeTag === 'search') {
          store.dispatch('setDeleteCacheInnerKeywordsEducation', id)
        }
      }
    }

    return {
      deleteTag
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-box {
  text-align: start;
  width: 100%;
  padding: 30px 16px;
  height: 200px;
  overflow-y: auto;
  background: #FFFFFF;
  border: 1px solid #000000;
  border-radius: 6px;

  &__header {
    margin-bottom: 36px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #787878;
  }

  &__content {
    margin-top: 15px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 3px 12px;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    background-color: #E31E24;
    border-radius: 6px;

    :deep(svg) {
      path {
        stroke: #FFFFFF;
      }
    }
  }
}
:deep(.base-button) {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
